import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { ServiceCatalogTable } from '~/components/funnel/service-catalog-table'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/funnel/catalog')({
  component: ServiceCatalogRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Services`) }] }),
})

function ServiceCatalogRoute() {
  return <ServiceCatalogTable />
}
